/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { ThreadSection } from '../ThreadSection';
import { SectionHeaderType, ThreadGroups, SECTION_TYPES } from '../../types';
import { map } from 'lodash';
import { useContext } from 'react';
import { InboxContext } from '../../containers/Inbox/InboxContext';
import { getFilteredThreads } from '../../utils/threadUtils';

export namespace ThreadSectionsGroup {
  export interface Props {
    threadGroups: ThreadGroups;
  }
}

export const ThreadSectionsGroup: React.FC<ThreadSectionsGroup.Props> = ({ threadGroups }) => {
  const {
    stylingConfig: { topic },
  } = useContext(InboxContext);

  return (
    <React.Fragment>
      {map(threadGroups, (threads, header) => (
        <ThreadSection
          header={SECTION_TYPES[header as SectionHeaderType]}
          key={`thread-group-${header}`}
          threads={getFilteredThreads(threads, topic)}
        />
      ))}
    </React.Fragment>
  );
};
